import {
    Box, HStack, Image, Text
} from "@chakra-ui/react";
const SocialMediaIcn = () => {
    return (
        <Box mb="100px" fontSize="14px" fontWeight="500">
            <Text>Like this property? Share with a friend.</Text>
            <HStack gap="8px">
                <Box _hover={{ transform: "translateY(-4px)" }} transition="transform 0.2s ease-out" border="1px solid #ccc" borderRadius="4px" w="38px" p="10px 10px">
                    <Image w="16px" h="16px" src="https://platform-cdn.sharethis.com/img/facebook-white.svg" />
                </Box>
                <Box _hover={{ transform: "translateY(-4px)" }} transition="transform 0.2s ease-out" border="1px solid #ccc" borderRadius="4px" w="38px" p="10px 10px">
                    <Image w="16px" h="16px" src="https://platform-cdn.sharethis.com/img/twitter-white.svg" />
                </Box>
                <Box _hover={{ transform: "translateY(-4px)" }} transition="transform 0.2s ease-out" border="1px solid #ccc" borderRadius="4px" w="38px" p="10px 10px">
                    <Image w="16px" h="16px" src="https://platform-cdn.sharethis.com/img/whatsapp-white.svg" />
                </Box>
                <Box _hover={{ transform: "translateY(-4px)" }} transition="transform 0.2s ease-out" border="1px solid #ccc" borderRadius="4px" w="38px" p="10px 10px">
                    <Image w="16px" h="16px" src="https://platform-cdn.sharethis.com/img/linkedin-white.svg" />
                </Box>
                <Box _hover={{ transform: "translateY(-4px)" }} transition="transform 0.2s ease-out" border="1px solid #ccc" borderRadius="4px" w="38px" p="10px 10px">
                    <Image w="16px" h="16px" src="https://platform-cdn.sharethis.com/img/email-white.svg" />
                </Box>

            </HStack>

        </Box>
    );
}

export default SocialMediaIcn;